import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'form'

const endpoint = '/api/setting/form'
export const resetForm = createApiAction('form/delete', client.destroy(`${endpoint}/:id`))

const sessionSlice = createSlice({
  name,
  initialState: {},
  reducers: {},
})

export default sessionSlice.reducer
